export default __webpack_public_path__ + "static/media/logout.a160dd9e.svg";